
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ProductSpecification } from "@/types/product";

interface ProductSpecificationsSectionProps {
  specifications: ProductSpecification[];
}

const ProductSpecificationsSection = ({
  specifications
}: ProductSpecificationsSectionProps) => {
  if (!specifications || specifications.length === 0) {
    return null;
  }

  // Group specifications by group
  const groupedSpecs = specifications.reduce((acc, spec) => {
    if (!acc[spec.specification_group]) {
      acc[spec.specification_group] = [];
    }
    acc[spec.specification_group].push(spec);
    return acc;
  }, {} as Record<string, ProductSpecification[]>);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Specifications</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {Object.entries(groupedSpecs).map(([group, specs]) => (
          <div key={group} className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground border-b pb-2">
              {group}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {specs
                .sort((a, b) => a.display_order - b.display_order)
                .map((spec) => (
                  <div key={spec.id} className="flex justify-between items-center py-2 border-b border-muted">
                    <span className="text-muted-foreground font-medium">
                      {spec.specification_key}:
                    </span>
                    <span className="text-foreground">
                      {spec.specification_value}
                    </span>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default ProductSpecificationsSection;
